import React, { useState } from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";
import fallbackSrc from "../assets/images/azores_lagoon_color_red1.webp";

function HeroImage() {
  const remoteSrc =
    "https://res.cloudinary.com/dzwnnnku5/image/upload/v1770333079/azores_lagoon_color_v7l9q0.jpg";
  const [src, setSrc] = useState(remoteSrc);

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
      sx={{
        /* width: {
          sm: "100%",
          md: "70%",
          lg: "60%",
        }, */
        alignContent: "center",
        // maxHeight: "700px",
        mb: 4,
        mt: { xs: 1, sm: 2, md: 2 },
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: "0 4px 12px rgba(26,58,82,0.1)",
      }}
    >
      <Box
        component="img"
        src={src}
        alt="Isabela & Tiago"
        loading="eager"
        onError={() => {
          if (src !== fallbackSrc) setSrc(fallbackSrc);
        }}
        sx={{
          /* width: "100%", */
          /* height: { xs: "450px", sm: "475px", md: "500px", lg: "530px" }, */
          height: { xs: "300px", sm: "350px", md: "500px", lg: "530px" },
          /* height: "530px", */
          width: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
          minHeight: { xs: "300px", sm: "350px", md: "450px", lg: "530px" },
          maxHeight: { xs: "300px", sm: "350px", md: "450px", lg: "530px" },
          display: "block",
          objectFit: "cover",
          WebkitObjectFit: "cover", // Safari support
          /* transform: {
            xs: "translate(-0%, -0%) scale(1)",
            sm: "translate(-0%, -0%) scale(1)",
            md: "translate(-0%, -0%) scale(1)",
            lg: "translate(-0%, 0%) scale(1)",
          }, */
          objectPosition: {
            // xs: "68% center",
            // sm: "40% center",
            md: "center center",
          },
          "@supports (-webkit-appearance:none)": {
            objectPosition: {
              lg: "center 25%",
            },
          },
          "@media (max-width: 360px)": {
            objectPosition: "60% center",
            WebkitObjectPosition: "60% center",
          },
        }}
      />
    </Box>
  );
}

export default HeroImage;
